import React from 'react'
import { motion } from 'framer-motion'

// Fades content up the first time it scrolls into view.
const Reveal = ({ children, delay = 0, y = 24, className, as = 'div' }) => {
  const Tag = motion[as]
  return (
    <Tag
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: '-60px' }}
      transition={{ duration: 0.7, delay, ease: [0.22, 1, 0.36, 1] }}
    >
      {children}
    </Tag>
  )
}

export default Reveal
